import ProjectCard from "../../components/Cards/ProjectCard"
import { PROJECTS } from "../../constants/constants"
import "./Projects.scss"

export default function Projects() {
    
    return (
        <div className="projects-section row">
            <div className="right-section d-flex flex-column col-12 col-sm-6">
                <ProjectCard 
                    name={PROJECTS.PROJECT_ONE.name} 
                    desc={PROJECTS.PROJECT_ONE.desc}
                    tech={PROJECTS.PROJECT_ONE.tech}
                    date={PROJECTS.PROJECT_ONE.date}
                    linkName={PROJECTS.PROJECT_ONE.link.name}
                    url={PROJECTS.PROJECT_ONE.link.url}
                    association={PROJECTS.PROJECT_ONE.association}
                />
                <ProjectCard 
                    name={PROJECTS.PROJECT_THREE.name} 
                    desc={PROJECTS.PROJECT_THREE.desc}
                    tech={PROJECTS.PROJECT_THREE.tech}
                    date={PROJECTS.PROJECT_THREE.date}
                    project_kind={PROJECTS.PROJECT_THREE.project_kind}
                />
                <ProjectCard 
                    name={PROJECTS.PROJECT_FIVE.name} 
                    desc={PROJECTS.PROJECT_FIVE.desc}
                    tech={PROJECTS.PROJECT_FIVE.tech}
                    date={PROJECTS.PROJECT_FIVE.date}
                    association={PROJECTS.PROJECT_FIVE.association}
                />
                <ProjectCard 
                    name={PROJECTS.PROJECT_SEVEN.name} 
                    desc={PROJECTS.PROJECT_SEVEN.desc}
                    tech={PROJECTS.PROJECT_SEVEN.tech}
                    date={PROJECTS.PROJECT_SEVEN.date}
                    linkName={PROJECTS.PROJECT_SEVEN.link.name}
                    url={PROJECTS.PROJECT_SEVEN.link.url}
                />
                <ProjectCard 
                    name={PROJECTS.PROJECT_NINE.name} 
                    desc={PROJECTS.PROJECT_NINE.desc}
                    tech={PROJECTS.PROJECT_NINE.tech}
                    date={PROJECTS.PROJECT_NINE.date}
                    linkName={PROJECTS.PROJECT_NINE.link.name}
                    url={PROJECTS.PROJECT_NINE.link.url}
                />
                <ProjectCard 
                    name={PROJECTS.PROJECT_ELEVEN.name} 
                    desc={PROJECTS.PROJECT_ELEVEN.desc}
                    tech={PROJECTS.PROJECT_ELEVEN.tech}
                    date={PROJECTS.PROJECT_ELEVEN.date}
                    association={PROJECTS.PROJECT_ELEVEN.association}
                />
                <ProjectCard 
                    name={PROJECTS.PROJECT_THIRTEEN.name} 
                    desc={PROJECTS.PROJECT_THIRTEEN.desc}
                    tech={PROJECTS.PROJECT_THIRTEEN.tech}
                    date={PROJECTS.PROJECT_THIRTEEN.date}
                    association={PROJECTS.PROJECT_THIRTEEN.association}
                />
                <ProjectCard 
                    name={PROJECTS.PROJECT_FIFTEEN.name} 
                    desc={PROJECTS.PROJECT_FIFTEEN.desc}
                    tech={PROJECTS.PROJECT_FIFTEEN.tech}
                    date={PROJECTS.PROJECT_FIFTEEN.date}
                    association={PROJECTS.PROJECT_FIFTEEN.association}
                /> 
            </div>
            <div className="left-section col-12 col-sm-6">
                <ProjectCard 
                    name={PROJECTS.PROJECT_TWO.name} 
                    desc={PROJECTS.PROJECT_TWO.desc}
                    tech={PROJECTS.PROJECT_TWO.tech}
                    date={PROJECTS.PROJECT_TWO.date}
                    project_kind={PROJECTS.PROJECT_TWO.project_kind}
                />
                <ProjectCard 
                    name={PROJECTS.PROJECT_FOUR.name} 
                    desc={PROJECTS.PROJECT_FOUR.desc}
                    tech={PROJECTS.PROJECT_FOUR.tech}
                    date={PROJECTS.PROJECT_FOUR.date}
                    association={PROJECTS.PROJECT_FOUR.association}
                />
                <ProjectCard 
                    name={PROJECTS.PROJECT_SIX.name} 
                    desc={PROJECTS.PROJECT_SIX.desc}
                    tech={PROJECTS.PROJECT_SIX.tech}
                    date={PROJECTS.PROJECT_SIX.date}
                    linkName={PROJECTS.PROJECT_SIX.link.name}
                    url={PROJECTS.PROJECT_SIX.link.url}
                    association={PROJECTS.PROJECT_SIX.association}
                /> 
                <ProjectCard 
                    name={PROJECTS.PROJECT_EIGHT.name} 
                    desc={PROJECTS.PROJECT_EIGHT.desc}
                    tech={PROJECTS.PROJECT_EIGHT.tech}
                    date={PROJECTS.PROJECT_EIGHT.date}
                    association={PROJECTS.PROJECT_EIGHT.association}
                />
                <ProjectCard 
                    name={PROJECTS.PROJECT_TEN.name} 
                    desc={PROJECTS.PROJECT_TEN.desc}
                    tech={PROJECTS.PROJECT_TEN.tech}
                    date={PROJECTS.PROJECT_TEN.date}
                    association={PROJECTS.PROJECT_TEN.association}
                />
                <ProjectCard 
                    name={PROJECTS.PROJECT_TWELVE.name} 
                    desc={PROJECTS.PROJECT_TWELVE.desc}
                    tech={PROJECTS.PROJECT_TWELVE.tech}
                    date={PROJECTS.PROJECT_TWELVE.date}
                    association={PROJECTS.PROJECT_TWELVE.association}
                />
                <ProjectCard 
                    name={PROJECTS.PROJECT_FOURTEEN.name} 
                    desc={PROJECTS.PROJECT_FOURTEEN.desc}
                    tech={PROJECTS.PROJECT_FOURTEEN.tech}
                    date={PROJECTS.PROJECT_FOURTEEN.date}
                    association={PROJECTS.PROJECT_FOURTEEN.association}
                />
                <ProjectCard 
                    name={PROJECTS.PROJECT_SIXTEEN.name} 
                    desc={PROJECTS.PROJECT_SIXTEEN.desc}
                    tech={PROJECTS.PROJECT_SIXTEEN.tech}
                    date={PROJECTS.PROJECT_SIXTEEN.date}
                    association={PROJECTS.PROJECT_SIXTEEN.association}
                />
            </div>
        </div>
    )
}